import { apiRequest } from '../../utils/apiHelper';
import { showServerError, showError } from '../../utils/toastHelper';


// Kullanıcıyı tamamen silme işlemi (Dikkatli kullanılmalı!)
export async function deleteUser(userId) {
  try {
    const response = await apiRequest(`/admin/users/${userId}`, {
      method: 'DELETE'
    });

    if (!response.success) {
      showError(response.message || 'Kullanıcı silinirken bir hata oluştu');
      throw new Error(response.message || 'Kullanıcı silinirken bir hata oluştu');
    }

    return response;
  } catch (error) {
    console.error('Delete user error:', error);
    if (error.isAuthError) {
      return;
    }
    if (error.apiError) {
      showServerError();
    }
    throw error;
  }
}

// Kullanıcıyı deaktif etme işlemi (Daha güvenli)
export async function deactivateUser(userId) {
  try {
    const response = await apiRequest(`/admin/users/${userId}/deactivate`, {
      method: 'PATCH'
    });

    if (!response.success) {
      showError(response.message || 'Kullanıcı deaktif edilirken bir hata oluştu');
      throw new Error(response.message || 'Kullanıcı deaktif edilirken bir hata oluştu');
    }

    return response;
  } catch (error) {
    console.error('Deactivate user error:', error);
    if (error.apiError) {
      showServerError();
    }
    throw error;
  }
}
